import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, ShieldCheck, FileWarning, Truck, Activity, ClipboardList } from "lucide-react";

export default function SuperAdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/super-admin/portal-stats");
        setStats(data);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading || !stats) return <div className="hs-overline">LOADING…</div>;

  return (
    <div className="space-y-6" data-testid="superadmin-dashboard">
      <div>
        <div className="hs-overline text-blue-700">CEO · OVERVIEW</div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tighter mt-2">Super Admin</h1>
        <p className="text-sm text-slate-500 mt-2">Managed-portal health at a glance.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat icon={Users} accent="#1D4ED8" label="MANAGED CLIENTS" value={stats.total_clients} testid="kpi-clients" />
        <Stat icon={Activity} accent="#059669" label="ACTIVE (30D)" value={stats.active_clients_30d} testid="kpi-active" />
        <Stat icon={ClipboardList} accent="#D97706" label="NEW LEADS" value={stats.open_leads} testid="kpi-leads" />
        <Stat icon={FileWarning} accent="#B91C1C" label="PENDING DOCS" value={stats.pending_documents} testid="kpi-pending" />
        <Stat icon={Truck} accent="#0F172A" label="DRIVERS TRACKED" value={stats.total_drivers} testid="kpi-drivers" />
        <Stat icon={ShieldCheck} accent="#0F172A" label="CSA SNAPSHOTS" value={stats.csa_snapshots} testid="kpi-csa" />
      </div>

      <div className="hs-card p-6">
        <div className="hs-overline">RECENT ACTIVITY</div>
        <h3 className="font-display font-bold text-xl mt-1">Last 30 days</h3>
        <div className="mt-4 grid sm:grid-cols-2 gap-4 text-sm">
          <Row label="Clients onboarded" value={stats.clients_added_30d} />
          <Row label="Documents uploaded" value={stats.documents_uploaded_30d} />
          <Row label="Filings updated" value={stats.filings_updated_30d} />
          <Row label="Emails sent" value={stats.emails_sent_30d} />
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, accent, testid }) {
  return (
    <div className="hs-card p-5" data-testid={testid}>
      <div className="flex items-center gap-2">
        <Icon size={14} style={{ color: accent }} />
        <span className="hs-overline text-[10px]">{label}</span>
      </div>
      <div className="font-display font-black text-3xl mt-2" style={{ color: accent }}>{value ?? 0}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b border-slate-100 py-2">
      <span className="text-slate-600">{label}</span>
      <span className="font-mono font-bold">{value ?? 0}</span>
    </div>
  );
}
